import React from 'react';
import gpt3Logo from '../../assets/logo.png';
import './footer.css';

const Footer = () => (
  <div className="gpt3__footer section__padding">
    <div className="gpt3__footer-heading">
      <h1 className="gradient__text">
        Take the journey with us. With Homebrew.
      </h1>
    </div>

    <div className="gpt3__footer-links">
      <div>
        <img src={gpt3Logo} alt="homebrew_logo" />
        <p> Toronto, ON<br /></p>
      </div>
      <div className="gpt3__footer-links_div">
        <h4>Get in touch</h4>
        <p>Toronto, ON</p>
        <p>(416) 236-2811</p>
        <p>info@homebrewmk.com</p>
      </div>
    </div>

    <div className="gpt3__footer-copyright">
      <p>@2021 Homebrew Marketing. All rights reserved.</p>
    </div>
  </div>
);

export default Footer;
